import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * JSONLDSchema Component
 * 
 * This component renders structured data (JSON-LD) for SEO optimization.
 * Schema.org markup helps search engines understand the content of the page
 * and can result in rich snippets in search results.
 */
const JSONLDSchema = ({ 
  type = 'WebSite',
  data = {},
  scriptKey = 'structured-data'
}) => {
  // Default data for the website
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    url: 'https://claus.co/',
    name: 'Claus - Software Contable y Facturación Electrónica',
    description: 'Software contable en la nube para empresas y contadores. Facturación electrónica, gestión fiscal y soluciones financieras para tu negocio.',
    potentialAction: {
      '@type': 'SearchAction',
      'target': 'https://claus.co/search?q={search_term_string}',
      'query-input': 'required name=search_term_string'
    },
    ...data
  };

  // Schema for the organization
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    url: 'https://claus.co/',
    name: 'Claus',
    logo: 'https://claus.co/static/logo-c8a5fe1c22c3fba1db9b26c32d3a3ea9.svg',
    description: 'Empresa especializada en soluciones contables y de facturación electrónica para empresas y contadores.',
    sameAs: [
      'https://twitter.com/clausco_co',
      'https://web.facebook.com/Clausoficialco',
      'https://www.youtube.com/@Clauserp',
      'https://www.linkedin.com/company/software-de-colombia/'
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+573493454678',
      contactType: 'customer service'
    },
    ...data
  };

  // Schema for the software application
  const softwareApplicationSchema = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'Claus - Software Contable',
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'COP'
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.8',
      ratingCount: '156'
    },
    ...data
  };

  let schemaData;

  // Select the appropriate schema based on the type
  switch(type) {
    case 'Organization':
      schemaData = organizationSchema;
      break;
    case 'SoftwareApplication':
      schemaData = softwareApplicationSchema;
      break;
    default: // 'WebSite'
      schemaData = websiteSchema;
      break;
  }

  return (
    <Helmet>
      <script 
        type="application/ld+json"
        key={scriptKey}
      >
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

export default JSONLDSchema;
